import type { DependencyList } from 'react'
import { useEffect, useCallback } from 'react'

import type { ProductFruits } from '../../types'
import { useProductFruitsIsReady } from '../useProductFruitsIsReady'

const useProductFruits = (
  productFruitCtxGetterCallback: (api: ProductFruits['api'] | null) => void,
  deps: DependencyList = []
) => {
  const memoizedProductFruitCtxGetterCallback = useCallback(productFruitCtxGetterCallback, [
    productFruitCtxGetterCallback,
    ...deps
  ])
  const productFruitsIsReady = useProductFruitsIsReady()

  useEffect(() => {
    if (typeof window === 'undefined' || !productFruitsIsReady) {
      memoizedProductFruitCtxGetterCallback(null)

      return
    }

    memoizedProductFruitCtxGetterCallback(window.productFruits?.api ?? null)
  }, [productFruitsIsReady, memoizedProductFruitCtxGetterCallback])
}

export default useProductFruits
